"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledButton = exports.Button = exports.BUTTON_TYPES = exports.BUTTON_ACTION_TYPE = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _CircularLoader = require("../CircularLoader");
var _Icon = require("../Icon");
var _Truncate = require("../Truncate");
var _ButtonModule = _interopRequireDefault(require("./Button.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BUTTON_TYPES = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  ghost: 'ghost',
  danger: 'danger'
});
exports.BUTTON_TYPES = BUTTON_TYPES;
const BUTTON_ACTION_TYPE = Object.freeze({
  button: 'button',
  submit: 'submit',
  reset: 'reset'
});
exports.BUTTON_ACTION_TYPE = BUTTON_ACTION_TYPE;
const ButtonTypeToIconColorMap = {
  primary: 'inversePrimary',
  secondary: 'clickable',
  tertiary: 'primary',
  ghost: 'primary',
  danger: 'inversePrimary'
};
const ButtonTypeToLoaderColorMap = {
  primary: 'colorTextInversePrimary',
  secondary: 'colorTextClickable',
  tertiary: 'colorTextPrimary',
  ghost: 'colorTextPrimary',
  danger: 'colorTextInversePrimary'
};
const UnstyledButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    disabled,
    onClick,
    className,
    ariaLabel,
    actionType,
    tabIndex = 0,
    isLoading,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("button", _extends({}, props, ariaLabel ? {
    'aria-label': ariaLabel
  } : {}, {
    className: className,
    ref: ref,
    role: "button",
    disabled: disabled,
    tabIndex: disabled ? -1 : tabIndex,
    type: actionType,
    onClick: event => {
      if (disabled || isLoading) {
        event.preventDefault();
      } else if (onClick) {
        onClick(event);
      }
    }
  }));
});
exports.UnstyledButton = UnstyledButton;
const Button = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    classNames,
    children,
    iconLeftName = '',
    iconLeftType = 'regular',
    iconRightName = '',
    iconRightType = 'regular',
    type = 'primary',
    isFluid = false,
    disabled = false,
    actionType = 'button',
    size = 'medium',
    isLoading,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(UnstyledButton, _extends({}, props, {
    actionType: actionType,
    disabled: disabled,
    isLoading: isLoading,
    className: (0, _classify.classify)(_ButtonModule.default.button, {
      [_ButtonModule.default.primary]: type === 'primary',
      [_ButtonModule.default.secondary]: type === 'secondary',
      [_ButtonModule.default.tertiary]: type === 'tertiary',
      [_ButtonModule.default.ghost]: type === 'ghost',
      [_ButtonModule.default.danger]: type === 'danger',
      [_ButtonModule.default.disabled]: disabled,
      [_ButtonModule.default.small]: size === 'small',
      [_ButtonModule.default.medium]: size === 'medium',
      [_ButtonModule.default.isFluid]: isFluid === true,
      [_ButtonModule.default.withIconLeft]: !!iconLeftName,
      [_ButtonModule.default.withIconRight]: !!iconRightName,
      [_ButtonModule.default.withBothIcon]: !!(iconLeftName && iconRightName),
      [_ButtonModule.default.onlyIcon]: (iconLeftName || iconRightName) && !children
    }, classNames?.wrapper),
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: _ButtonModule.default.buttonRow
  }, !(iconLeftName || iconRightName) ? /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_ButtonModule.default.textContainer, classNames?.text)
  }, isLoading && /*#__PURE__*/React.createElement("div", {
    className: _ButtonModule.default.loader
  }, /*#__PURE__*/React.createElement(_CircularLoader.CircularLoader, {
    size: size,
    colorToken: disabled ? 'colorTextDisabled' : ButtonTypeToLoaderColorMap[type]
  })), /*#__PURE__*/React.createElement(_Truncate.Truncate, {
    className: (0, _classify.classify)({
      [_ButtonModule.default.hidden]: isLoading
    })
  }, children)) :
  // has icon, but no child
  children == null ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoading && /*#__PURE__*/React.createElement("div", {
    className: _ButtonModule.default.loader
  }, /*#__PURE__*/React.createElement(_CircularLoader.CircularLoader, {
    size: size,
    colorToken: disabled ? 'colorTextDisabled' : ButtonTypeToLoaderColorMap[type]
  })), /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconLeftName || iconRightName,
    color: disabled ? 'disabled' : ButtonTypeToIconColorMap[type],
    size: size === 'medium' ? 'medium' : 'small',
    type: iconLeftName ? iconLeftType : iconRightType,
    className: (0, _classify.classify)({
      [_ButtonModule.default.hidden]: isLoading
    }, classNames?.icon)
  })) :
  // has icon _and_ child
  (iconLeftName || iconRightName) && /*#__PURE__*/React.createElement(React.Fragment, null, iconLeftName && /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconLeftName,
    color: disabled ? 'disabled' : ButtonTypeToIconColorMap[type],
    size: size === 'medium' ? 'medium' : 'small',
    type: iconLeftType,
    className: (0, _classify.classify)({
      [_ButtonModule.default.hidden]: isLoading
    }, classNames?.icon)
  }), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_ButtonModule.default.textContainer, classNames?.text)
  }, isLoading && /*#__PURE__*/React.createElement("div", {
    className: _ButtonModule.default.loader
  }, /*#__PURE__*/React.createElement(_CircularLoader.CircularLoader, {
    size: size,
    colorToken: disabled ? 'colorTextDisabled' : ButtonTypeToLoaderColorMap[type]
  })), /*#__PURE__*/React.createElement(_Truncate.Truncate, {
    className: (0, _classify.classify)({
      [_ButtonModule.default.hidden]: isLoading
    })
  }, children)), iconRightName && /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconRightName,
    color: disabled ? 'disabled' : ButtonTypeToIconColorMap[type],
    size: size === 'medium' ? 'medium' : 'small',
    type: iconRightType,
    className: (0, _classify.classify)({
      [_ButtonModule.default.hidden]: isLoading
    }, classNames?.icon)
  }))));
});
exports.Button = Button;
Button.name = Button.displayName = 'Button';